/**
 * Default icons mapping.
 *
 * This object contains default FontAwesome class names for commonly used icons.
 */
const defaultIcons = {
  save: "fa-floppy-disk",
  edit: "fa-pencil",
  cancel: "fa-circle-xmark",
  delete: "fa-trash-alt",
  drag: "fa-up-down-left-right",
  verticalMenu: "fa-ellipsis-vertical",
  info: "fa-circle-info",
  draft: "fa-clipboard",
  chat: "fa-comment",
  video: "fa-film",
  add: "fa-circle-plus",
  unlink: "fa-link-slash",
  link: "fa-link",
  search: "fa-magnifying-glass",
  view: "fa-eye",
  sloCorePurpose: "fa-bullseye",
  sloTarget: "fa-frame",
  cluster: "fa-list-tree",
  warning: "fa-triangle-exclamation",
  negative: "fa-circle-exclamation",
  required: "fa-hexagon-exclamation",
  positive: "fa-circle-check",
  folder: "fa-folder-closed",
  attachment: "fa-paperclip",
  users: "fa-user-group",
  usersChecked: "fa-user-check",
  calendar: "fa-calendar-days",
  deadline: "fa-alarm-clock",
  source: "fa-map-pin",
  plan: "fa-plus-circle",
  duplicate: "fa-copy",
  import: "fa-download",
  gift: "fa-gift",
};

const portfolioIcons = {
  assessmentModels: {
    grade: "fa-award",
    simple: "fa-award",
  },
};

const editorIcons = {
  bold: "fa-bold",
  italic: "fa-italic",
  underline: "fa-underline",
  ordered: "fa-list-ol",
  unordered: "fa-list-ul",
  image: "fa-image",
  link: "fa-link-simple",
  unlink: "fa-link-simple-slash",
  code: "fa-code",
};

const manageFeatureIcons = {
  publish: "fa-upload",
  unpublish: "fa-eye-slash",
};

/**
 * Converts a given FontAwesome icon class to its duotone variant.
 *
 * @param {string} icon - The base FontAwesome icon class (e.g., "fa-pencil").
 * @returns {string} The modified class name with the "fa-duotone" prefix.
 */
export const toDuotoneIcon = (icon) => {
  return `fa-duotone ${icon}`;
};

/**
 * Converts a given FontAwesome icon class to its solid variant.
 *
 * @param {string} icon - The base FontAwesome icon class (e.g., "fa-pencil").
 * @returns {string} The modified class name with the "fa-solid" prefix.
 */
export const toSolidIcon = (icon) => {
  return `fa-solid ${icon}`;
};

export const toLightIcon = (icon) => {
  return `fa-light ${icon}`;
};

export const saveIcon = defaultIcons.save;
export const editIcon = defaultIcons.edit;
export const cancelIcon = defaultIcons.cancel;
export const deleteIcon = defaultIcons.delete;
export const dragIcon = defaultIcons.drag;
export const verticalMenuIcon = defaultIcons.verticalMenu;
export const infoIcon = defaultIcons.info;
export const draftIcon = defaultIcons.draft;
export const chatIcon = defaultIcons.chat;
export const videoIcon = defaultIcons.video;
export const addIcon = defaultIcons.add;
export const searchIcon = defaultIcons.search;
export const viewIcon = defaultIcons.view;
export const unlinkIcon = defaultIcons.unlink;
export const linkIcon = defaultIcons.link;
export const sloCorePurposeIcon = defaultIcons.sloCorePurpose;
export const sloTargetIcon = defaultIcons.sloTarget;
export const clusterIcon = defaultIcons.cluster;
export const warningIcon = defaultIcons.warning;
export const negativeIcon = defaultIcons.negative;
export const positiveIcon = defaultIcons.positive;
export const assessmentGradeIcon = portfolioIcons.assessmentModels.grade;
export const assessmentSimpleIcon = portfolioIcons.assessmentModels.simple;
export const requiredIcon = defaultIcons.required;
export const folderIcon = defaultIcons.folder;
export const attachmentIcon = defaultIcons.attachment;
export const usersIcon = defaultIcons.users;
export const usersCheckedIcon = defaultIcons.usersChecked;
export const calendarIcon = defaultIcons.calendar;
export const deadlineIcon = defaultIcons.deadline;
export const sourceIcon = defaultIcons.source;
export const planIcon = defaultIcons.plan;
export const duplicateIcon = defaultIcons.duplicate;
export const importIcon = defaultIcons.import;

export const giftIcon = defaultIcons.gift;

// WYSIWYG Editor icons
export const editorBold = editorIcons.bold;
export const editorItalic = editorIcons.italic;
export const editorUnderline = editorIcons.underline;
export const editorOrdered = editorIcons.ordered;
export const editorUnordered = editorIcons.unordered;
export const editorImage = editorIcons.image;
export const editorLink = editorIcons.link;
export const editorCode = editorIcons.code;
export const editorUnlink = editorIcons.unlink;

// Manage Feature icons
export const manageFeaturePublishIcon = manageFeatureIcons.publish;
export const manageFeatureUnpublishIcon = manageFeatureIcons.unpublish;
